import styled from 'styled-components';

export const RangeSliderWrapper = styled.div`
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 25px;
`;
